import React, { useState } from 'react'
import { Container, Row } from 'react-bootstrap'
import styled from 'styled-components'
import { Box, LazyImage, SpanStyled } from '../Elements'
import { FooterBg, FooterLogo, Instagram, LinkedIn, Logo, Snapchat, Tiktok, Twitter } from '../AllImages'
import { NavDataConfig } from '../../components/projectData/Data'
import { Link } from 'react-scroll'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

const Footer = () => {
    const navigate = useNavigate()
    const { t } = useTranslation();
    const date_year = new Date();
    const SocialLinkSnap = () => {
        window.open('#!', '_blank');
    };
    const SocialLinkLinkedIn = () => {
        window.open('#!', '_blank');
    };
    const SocialLinkInstagram = () => {
        window.open('https://www.instagram.com/sheelandmore?igsh=MW8xMHVzOHhsODUweg==', '_blank');
    };
    const SocialLinkTwitter = () => {
        window.open('https://x.com/sheelandmore?s=11', '_blank');
    };
    return (
        <FooterWapper className='container-fluid footerFluid'>
            <Container>
                <Row>
                    <Box className='footerContentContainer'>
                        <Box className='footerLogo'>
                            <Logo />
                        </Box>
                        <SpanStyled className='copyRightDes' size='14px' color='var(--white)' transform='capitalize'>{t('All_Rights_Reserved')} <span className='txtEng'>&copy; {date_year.getFullYear()}</span> {t("Sheel")}</SpanStyled>
                        <Box className='d-flex align-items-center socialLinksContainer'>
                            {/* <Box className='socialLinks'><Snapchat onClick={SocialLinkSnap} /></Box>
                            <Box className='socialLinks'><LinkedIn onClick={SocialLinkLinkedIn} /></Box> */}
                            <Box className='socialLinks'><Instagram onClick={SocialLinkInstagram} /></Box>
                            <Box className='socialLinks'><Twitter onClick={SocialLinkTwitter} /></Box>
                        </Box>
                        
                        
                    </Box>
                </Row>
            </Container>
            {/* <ChangeButton /> */}
        </FooterWapper>
    )
}
const FooterWapper = styled.footer`
    position:relative;
    padding: 22px 0 22px 0px;
    background-color: var(--themeColor);
    .container{
        position: relative;
    }
    .footerContentContainer{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .socialLinks{
        cursor: pointer;
    }
    .socialLinksContainer{
        display: flex;
        gap: 16px;
        
    }
    @media (max-width: 767px) {
        .footerContentContainer{
            flex-wrap: wrap;
            gap: 15px;
            justify-content: center;
            span{
                width: 100%;
                text-align: center;
            }
        }
        .footerLogo{
            width: 100%;
            display: flex;
            justify-content: center;
        }
        
    }

`
export default Footer
